import { Transformations, enhanceImageUrl } from 'utils';
import { Banner } from './model-json-types';

/**
 * Добавляет к урлу изображения модификаторы
 * @param {Banner[]} bannerList
 * @param {Transformations} transformations
 * @returns {Banner[]}
 */
export const modifyBannerImages = (bannerList: Banner[], transformations?: Transformations) =>
  bannerList.map(({ image, ...rest }) => ({
    ...rest,
    image: enhanceImageUrl(image, transformations),
  }));
